var XMLNode = require("../xml/XMLNode");

/**
 * The SharedString class represents each shared String within the
 * SharedStrings file.
 *
 * @param {string} sValue - The String that gets represented by this SharedString object
 * @class
 */
function SharedString(sValue) {
	XMLNode.call(this, SharedString.metadata);

	this.setValue(sValue);
}

SharedString.prototype = Object.create(XMLNode.prototype);
SharedString.prototype.constructor = SharedString;

SharedString.spacePreserveAttributeId = "spacePreserve";

// eslint-disable-next-line no-control-regex, max-len
SharedString.controlCharacterTestRegex = /[\x00\x01\x02\x03\x04\x05\x06\x07\x08\x0B\x0C\x0E\x0F\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1A\x1B\x1C\x1D\x1E\x1F]/m;
// eslint-disable-next-line no-control-regex, max-len
SharedString.controlCharacterReplaceRegex = /[\x00\x01\x02\x03\x04\x05\x06\x07\x08\x0B\x0C\x0E\x0F\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1A\x1B\x1C\x1D\x1E\x1F]/gm;

// Matches space either at the beginning or the end
SharedString.spacePreserveRegex = /^ | $/;

SharedString.metadata = {
	tag: "si",
	properties: [
		{
			id: "text",
			tag: "t"
		}
	]
};

/**
 * Replaces XML incompatible control characters with their corresponding Office Open XML escape sequence.
 *
 * @param {string} sValue - String that contains ASCII control characters
 * @returns {string} - Escaped string
 * @private
 */
SharedString._escapeControlCharacters = function(sValue) {
	var sCharHex;

	return sValue.replace(SharedString.controlCharacterReplaceRegex, function(sMatch) {
		sCharHex = sMatch.codePointAt(0).toString(16).toUpperCase();

		/* Works only with control characters in ASCII range - do NOT use with Emojis */
		return "_x00" + (sCharHex.length === 1 ? "0" : "") + sCharHex + "_";
	});
};

/**
 * Assigns the given value to the current SharedString instance.
 *
 * @function
 * @param {string} sValue - The string value that should be added
 */
SharedString.prototype.setValue = function(sValue) {

	this.text.remove(SharedString.spacePreserveAttributeId);

	if (SharedString.controlCharacterTestRegex.test(sValue)) {
		sValue = SharedString._escapeControlCharacters(sValue);
	}

	if (SharedString.spacePreserveRegex.test(sValue)) {
		this.text.addAttribute({
			id: SharedString.spacePreserveAttributeId,
			name: "space",
			prefix: "xml",
			value: "preserve"
		});
	}

	if (sValue && typeof sValue == "string") {
		this.text.value = sValue;
	} else {

		/**
		 * There are other implementations for creating a string
		 * representation out of a number that might be more
		 * convenient like new String(number).toString() or
		 * number.toString() but "" + number is the best performing.
		 */
		this.text.value = "" + sValue;
	}
};

/**
 * Serializes the XMLNode and transforms the concatenated string into a sequential string.
 * @return {string} - String representation of the SharedString
 *
 * @override
 */
SharedString.prototype.serialize = function() {
	var sSerialized;

	sSerialized = Object.getPrototypeOf(SharedString.prototype).serialize.call(this);

	return (" " + sSerialized).substr(1);
};

module.exports = SharedString;